/**
 * Hide Skio selling plans in the ReCharge cart-drawer overlay
 * ==========================================================
 * TEMPORARY — PRE-LAUNCH ONLY. Delete this file, its snippet and its settings
 * when the ReCharge storefront ScriptTag is removed at launch.
 *
 * WHY
 * ReCharge's Storefront Experiences cart overlay lists every selling plan
 * allocated to the added variant, regardless of which app owns it. Once Skio
 * groups are attached to a product, its plans appear in ReCharge's upsell and a
 * customer could subscribe on the wrong platform before launch.
 *
 * The overlay is a React app rendered into a closed-off shadow root by a
 * store-level ScriptTag. No Liquid filter reaches it, and ReCharge exposes no
 * admin control over which frequencies appear — the only related setting is
 * whether the customer may choose one at all.
 *
 * APPROACH
 * Remove the offending <option> elements after each mount. React's vdom still
 * holds them, but because nothing else about the surviving nodes changes,
 * reconciliation is a no-op and internal state stays correct. Verified: quantity
 * changes and plan changes both continue to work after removal.
 *
 * A deny-list is used rather than resolving plans per product: there are ~15
 * Skio plan ids versus ~92 ReCharge ones, and it avoids a network round trip
 * racing the overlay mount.
 *
 * KEEPING THE LIST CURRENT
 * Skio issues new plan ids when groups are created, and this list going stale
 * fails silently — a plan that isn't listed simply shows. Regenerate from a
 * fresh audit whenever Skio plans change:
 *
 *   python3 - <<'EOF'
 *   import csv
 *   rows = csv.DictReader(open('detailed.csv', encoding='utf-8-sig'))
 *   ids = sorted({r['selling_plan_id'].rsplit('/',1)[-1]
 *                 for r in rows if r['selling_plan_group_app_id'] == 'SKIO'})
 *   print(','.join(ids))
 *   EOF
 *
 * Paste the result into Theme settings → Skio: hide plans in ReCharge upsell.
 */
(function () {
  'use strict';

  var CFG = window.SkioHidePlansInRechargeUpsell || {};
  if (!CFG.enabled) return;

  var HIDE = {};
  (CFG.planIds || []).forEach(function (id) {
    id = String(id).trim();
    if (id) HIDE[id] = true;
  });
  if (!Object.keys(HIDE).length) return; // nothing configured — do nothing

  var HOST_ID = CFG.hostId || 'recharge-storefront-experiences__cart-overlay';
  var SELECT = 'select[name="selling_plan"]';
  var log = CFG.debug ? function () {
    console.log.apply(console, ['[skio-upsell-filter]'].concat([].slice.call(arguments)));
  } : function () {};

  /**
   * React owns this select. Assigning .value directly updates the DOM but not
   * React's state, so the native setter is used and a bubbling change event
   * dispatched — that is the path React's synthetic event system listens on.
   */
  function setValue(sel, value) {
    var d = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value');
    if (d && d.set) d.set.call(sel, value);
    else sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function filter(root) {
    var sel = root.querySelector(SELECT);
    if (!sel) return;

    var wasSelected = sel.value;
    var removed = 0;
    [].slice.call(sel.options).forEach(function (o) {
      if (HIDE[String(o.value)]) { o.remove(); removed++; }
    });
    if (!removed) return;

    log('removed', removed, 'plan option(s);', sel.options.length, 'remaining');

    // Guard: a product with no remaining plans shouldn't render an empty select.
    // Not expected during the migration — every product with Skio plans also has
    // ReCharge ones — but an empty dropdown is worse than a hidden upsell.
    if (!sel.options.length) {
      var panel = sel.closest('[role="dialog"]') || sel.closest('div');
      if (panel) panel.style.display = 'none';
      log('no plans left — overlay hidden');
      return;
    }

    // If the option that was selected has just been removed, move the selection
    // so the line item and price reflect a plan that actually exists.
    if (!sel.value || HIDE[String(wasSelected)]) setValue(sel, sel.options[0].value);
  }

  /**
   * The host element and its shadowRoot are created once and persist; only the
   * drawer contents mount and unmount inside. So one observer on the shadow root
   * catches every open, and no polling is needed after the initial wait.
   */
  function attach(host) {
    var root = host.shadowRoot;
    if (!root) return false;
    filter(root);
    new MutationObserver(function () { filter(root); })
      .observe(root, { childList: true, subtree: true });
    log('observer attached');
    return true;
  }

  var waited = 0;
  var poll = setInterval(function () {
    var host = document.getElementById(HOST_ID);
    if (host && attach(host)) { clearInterval(poll); return; }
    waited += 100;
    if (waited >= (CFG.timeout || 15000)) {
      clearInterval(poll);
      log('gave up waiting for #' + HOST_ID);
    }
  }, 100);
})();
